/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Modify_TitleInputs */

const en_cad_features_modify_title = /** @type {(inputs: Cad_Features_Modify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit geometry the way you already do`)
};

/**
* | output |
* | --- |
* | "Edit geometry the way you already do" |
*
* @param {Cad_Features_Modify_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_modify_title = /** @type {((inputs?: Cad_Features_Modify_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Modify_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_modify_title(inputs)
});
export { cad_features_modify_title as "cad.features.modify_title" }